import { render, staticRenderFns } from "./SidebarStickyButtons.vue?vue&type=template&id=54edf106&scoped=true&"
import script from "./SidebarStickyButtons.vue?vue&type=script&lang=js&"
export * from "./SidebarStickyButtons.vue?vue&type=script&lang=js&"
import style0 from "./SidebarStickyButtons.vue?vue&type=style&index=0&id=54edf106&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54edf106",
  null
  
)

export default component.exports